import {useSelector} from 'react-redux'

/**
 * returns a function that returns a bool when given a feature key
 */
export default function useShouldShowFeature () {
	const currentUser = useSelector(
		state => state.users?.current_user
	)

	const userClientFeatures = useSelector(
		state => state.layout.userClientFeatures
	)
	//build map from feature key to enabled
	const enabledMap = {}
	userClientFeatures.forEach(
		({feature_key,enabled})=>{
			enabledMap[feature_key] = Boolean(enabled)
		}
	)

	//gyms/trainers/chains should always have all features visible
	//so return a function that always returns true
	if (currentUser?.account_type!=='client') return _ => true
	
	return featureKey => enabledMap[featureKey]

}